<template>
    <div>
        <div class="right_table" :class="{showLeft:!showLeft}">

            <x-grid
                    :id="'formList'"
                    :rowId="rowId"
                    :pager-config="pagerConfig"
                    :form-config="formConfig"
                    :url="url"
                    :columns="columns"
                    :checkbox-config="checkboxConfig"
                    :toolbar-config="toolbarConfig"
                    :print-config="printConfig"
                    :export-config="exportConfig"
                    ref="grid"
                    :cellClick="chooseRow"
                    :cellDbClick="updateRow"
                    @toolbar-addData="addRow"
                    @toolbar-delData="delRow"
            >
                <template v-slot:[toolbarConfig.templatelSlots]>
                    <vxe-button @click="delRow"><a-icon type="delete"/> 删除</vxe-button>
                </template>
                <template v-slot:operate="{row}">
                    <a v-if="row.status === 2 && (row.val3 == '成员管理' || row.val3 == '角色管理' || row.val3 =='系统日志')" style="text-decoration: underline;color: #0158ff;" :href="api.temp.FILE_PATH + row.url+ '?token=' + token" target="_blank">
                        下载该附件
                    </a>
                    <a v-if="row.status === 2 && row.val3!='成员管理'&& row.val3!='角色管理'&& row.val3!='系统日志'" style="text-decoration: underline;color: #0158ff;" :href="api.temp.FILE_EXPORT + row.url+ '?token=' + token" target="_blank">
                        下载该附件
                    </a>
                    <a v-if="row.status != 2" style="text-decoration: underline;color: #999999;">
                        下载该附件
                    </a>
                </template>
            </x-grid>

        </div>
    </div>
</template>

<script>
    import XGrid from "@/components/grid/XGrid";
    import {GridMixin} from "@/utils/GridMixin";
    import {formatter as fmt} from "@/utils/ebase-formatter";
    import api from "@/services/api";
    import {loadBaseCodeData} from "@/services/baseCodeSource";

    console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除
    import {dataApi} from "@/services/comm/dowmloadCenter";
    import VXETable from "vxe-table";
    // import {mapMutations} from "vuex";
    //新增的
    // import {XEUtils} from "@/utils/common/FormBase";
    // import Tree from "@/components/picker/Tree";

    //新增的结束
    const fac = XGrid.factory;

    //列表接口
    const url = api.report.CLUBREPORT;

    //主键
    const rowId = "acitvityId";

    //列
    const columns = [
        fac.makeColumnCheckboxDefault(),
        fac.makeColumnSeqDefault(),
        fac.makeColumn("val3", "功能模块", 140, "center"),
        fac.makeColumn("fileSize", "文件大小", 140, "center"),
        fac.makeColumn("originalFilename", "文件名称", 140, "center"),
        fac.makeColumn("createDate", "导出时间", 140, "center"),
        fac.makeColumn("statusName", "状态", 160, "center"),
        // fac.makeColumn({
        //     width: 160,
        //     field: 'url', title: '地址 (下载后解压即)', slots: {default: 'download'},
        //     align:'center',
        //     sortable: true
        // }),
        fac.makeColumn({
            title: "下载地址",
            field: 'url',
            slots: {
                default: 'default'
            },
            align: 'center',
            width: 200,
        }),
    ];

    const formConfig = fac.makeFormConfig(columns, [
        {
            field: 'val3',
            type: 'select',
            options: [],
            title: '功能模块'
        },
        {field: 'lastModifyTime', type: 'dateRange',title:'导出时间'},
    ]);

    //工具栏按钮
    const toolbarConfig = fac.makeToolbarConfig({
        export: false,
        import: false,
        delData: false,
        addData: false,
        templatelSlots: "toolbarBtns",
    });

    //可编辑表格约束
    const printConfig = fac.makePrintConfig(columns);
    const pagerConfig = fac.makePagerConfig();
    const checkboxConfig = fac.makeCheckboxConfig(columns);

    async function loadBaseData() {
        let modelList=[]
        let arr = []
        let lrr = await dataApi.getData();
        for(let key in lrr.data){
            arr.push(lrr.data[key])
        }
        modelList.push({label: '全部', value: ''})
        for(let i=0; i<arr.length;i++){
            let obj= {}
            obj.value = arr[i]
            obj.label = arr[i]
            modelList.push(obj)
        }
        this.formConfig.items[0].itemRender.options = modelList;
    }


    export default {
        mixins: [GridMixin],
        authorize: {
            // addRow: "ADD",
            // updateRow: 'UPDATE',
            // delRow: 'DELETE',
            // importMethod:'IMPORT',
            // exportMethod:'EXPORT',
        },
        components: {
        },
        computed: {
        },
        watch: {
            $route: {
                handler: function (newValue, oldValue) {
                    if (oldValue && newValue.path === '/report/downloadCenter') {
                        this.startDate = this.$store.state.setting.startTime || null
                        this.endDate = this.$store.state.setting.endTime || null
                        this.$nextTick(() => {
                            this.refresh()
                        })
                    } else {
                        // this.setStartTime(null)
                        // this.setEndTime(null)
                    }
                },
                immediate: true,
            }
        },
        data() {
            return {
                columns,
                rowId,
                url,
                formConfig,
                toolbarConfig,
                printConfig,
                checkboxConfig,
                pagerConfig,
                natureOptions: [],
                cstegoryOptions: [],
                regionOptions: [],
                dealerOptions: [],
                visible: false,
                value: 1,
                token: localStorage.getItem('token'),
                defaultExpandedKeys: [],
                checkedKeys: [],
                deptList: [],
                showLeft: false,
                type: 'dept',
                //  新增的结束
            };
        },
        mounted() {
        },
        methods: {
            loadBaseData,
            onCheck(checkedKeys) {
                this.checkedKeys = checkedKeys;
            },
            delRow(){
                let rows = this.getRows()
                if (!rows.length) {
                    this.$message.warn('请至少选择一条数据')
                    return false
                } else {
                    if(rows.length == 1){
                        // this.moveVisible = true;
                        this.delIds = rows.map(item => item.id).toString();
                        VXETable.modal.confirm('您确定要删除该数据?','消息提示').then(type => {
                            console.log(type);
                            if (type === 'confirm') {
                                this.handleOkdelete()
                            }
                        })
                    }else{
                        // let idList=[]
                        // rows.forEach(item=>{
                        //     idList.push(item.id)
                        // })
                        this.delIds = rows.map(item => item.id).toString();
                        VXETable.modal.confirm('您确定要删除该数据?','消息提示').then(type => {
                            console.log(type);
                            if (type === 'confirm') {
                                this.handleOkdeletes()
                            }
                        })

                    }
                }
            },

            /**
             * 单选删除接口
             * @returns {Promise<void>}
             */
            async handleOkdelete(){
                // entities.id = vm.rowId;
                let res = await dataApi.delData(this.delIds);
                if(res.code === 200){
                    this.$message.success('操作成功');
                }else{
                    this.$message.error('操作失败');
                }
                this.refresh();
            },
            /**
             * 批量删除接口
             * @returns {Promise<void>}
             */
            async handleOkdeletes(){
                let res = await dataApi.delDataList(this.delIds);
                if(res.code === 200){
                    this.$message.success('操作成功');
                }else{
                    this.$message.error('操作失败');
                }
                this.refresh();
            },
        },
    };
</script>

<style scoped lang="less">
    /deep/ .ant-radio-group {
        display: flex;
        width: 100%;

        .ant-radio-wrapper {
            flex: 1;
        }

        .item {
            margin: 16px 0;
        }
    }
    //新增的开始

    .left_tree {
        width: 260px;
        float: left;
        padding: 20px;
        height: calc(100vh - 48px - 64px);
        border-right: 1px solid #e0e0e0;
        background: #fff;
        overflow-y: scroll;
        overflow-x: hidden;
        position: relative;
    }

    .right_table {
        width: calc(100% - 260px);
        float: right;
        height: 100%;
        position: relative;

        .close {
            position: absolute;
            top: 50%;
            left: -18px;
            display: block;
            z-index: 1000;
            font-size: 36px;
            cursor: pointer;
            color: #fff;
            background-color: #bbb;
            border-radius: 18px;
        }
    }

    .showLeft {
        width: 100%;
    }

    //新增的结束
</style>
